import { Box, Button, Typography } from '@mui/material';
import { useState } from 'react';

const MultipleImageUploader = ({ 
  images = [], 
  onImagesUpdate, 
  buttonLabel = 'Add Images' 
}) => {
  const [error, setError] = useState(null);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files);
    if (!files.length) return;

    // Validate each file
    const validTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];
    const maxSize = 5 * 1024 * 1024; // 5MB in bytes
    
    const invalidTypeFile = files.find(file => !validTypes.includes(file.type));
    if (invalidTypeFile) {
      setError(`${invalidTypeFile.name} is not a valid image type. Please use JPEG, PNG, GIF, or WEBP.`);
      return;
    }
    
    const oversizeFile = files.find(file => file.size > maxSize);
    if (oversizeFile) {
      setError(`${oversizeFile.name} exceeds the 5MB size limit.`);
      return;
    }

    // Process valid files
    const newImages = files.map(file => ({
      file,
      previewUrl: URL.createObjectURL(file),
      fileName: file.name,
      isNew: true
    }));

    // Update parent component with new images
    onImagesUpdate([...images, ...newImages]);
    setError(null);
    
    // Clear the input value so the same files can be selected again if needed
    event.target.value = '';
  };

  const handleRemoveImage = (indexToRemove) => {
    const updatedImages = images.filter((_, index) => index !== indexToRemove);
    
    // Release object URL to prevent memory leaks
    const removedImage = images[indexToRemove];
    if (removedImage.isNew && removedImage.previewUrl) {
      URL.revokeObjectURL(removedImage.previewUrl);
    }
    
    onImagesUpdate(updatedImages);
  };

  return (
    <Box>
      <Box sx={{ mb: 2 }}>
        <input
          type="file"
          accept="image/*"
          id="multiple-image-upload"
          onChange={handleFileChange}
          multiple
          style={{ display: 'none' }}
        />
        <label htmlFor="multiple-image-upload">
          <Button
            variant="outlined"
            component="span"
          >
            {buttonLabel}
          </Button>
        </label>
        
        {error && (
          <Typography color="error" variant="caption" display="block" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
      </Box>
      
      {images.length > 0 && (
        <Box sx={{ mt: 2, mb: 3, display: 'flex', flexWrap: 'wrap', gap: 2 }}>
          {images.map((img, index) => (
            <Box key={index} sx={{ position: 'relative', width: 150 }}>
              <img 
                src={img.previewUrl || img.url} 
                alt={`Project Image ${index + 1}`} 
                style={{ width: '100%', height: 'auto', borderRadius: '4px' }} 
              />
              <Button 
                variant="contained" 
                color="error" 
                size="small"
                sx={{ position: 'absolute', top: 5, right: 5 }}
                onClick={() => handleRemoveImage(index)}
              >
                X
              </Button>
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default MultipleImageUploader; 